import { createContext } from 'react'

export type TranslationContextProps = {
  translationsSet: boolean
  getTranslation: (group: string, name: string | number, data?: { [key: string]: string | number }) => string
  getRawTranslation: (group: string, name: string | number, data?: { [key: string]: string | number }) => string
}

const TranslationContext = createContext<TranslationContextProps>(null)

export default TranslationContext
